import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';
import { container, navBarHeight } from 'UI/constants/dimensions';

const BORDER_STYLE = `1px solid ${THEME.palette.customColors.borderColor}`;
const dualPanelLayoutHeaderHeight = 76;

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    height: `calc(100vh - ${navBarHeight}px)`,
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[50]
  },
  panelContainer: {
    border: BORDER_STYLE,
    backgroundColor: theme.palette.grey[50],
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  rightPanel: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  leftHeaderContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],

    '& .MuiAutocomplete-root': {
      overflow: 'hidden',
      paddingTop: theme.spacing(1)
    },
    '& .MuiInputLabel-root': {
      whiteSpace: 'nowrap'
    }
  },
  leftHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1)
  },
  leftContent: {
    flexGrow: 1,
    overflowY: 'auto',
    paddingBottom: theme.spacing(3),
    position: 'relative'
  },
  rightHeaderContainer: {
    backgroundColor: theme.palette.grey[50],
    boxShadow: container.boxShadow,
    padding: theme.spacing(2),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rightHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  rightHeaderTitle: {
    marginLeft: theme.spacing(1)
  },
  rightContentContainer: {
    backgroundColor: theme.palette.grey[50],
    height: `calc(100% - ${dualPanelLayoutHeaderHeight}px)`,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  divider: {
    width: 8,
    cursor: 'col-resize',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[200],
    '&:hover $dividerHandle': {
      backgroundColor: theme.palette.primary.main
    }
  },
  dividerHandle: {
    width: 2,
    height: 40,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 2
  }
}));
